import { OccConfig } from '@spartacus/core';

export const contactOurExpertsOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        topic: '/contact-experts/topic',
        subTopic: '/contact-experts/topic/${topicCode}',
        option: '/contact-experts/option/${subTopicCode}',
        contactForm: '/contact-experts/contact',
      } as any,
    },
  },
};
